// API base URLs are environment configuration and live in services/env.ts.
// They are deliberately not re-exported from here: this module is imported by
// the API client, and pulling env.ts onto that path would make every unit test
// depend on a fully populated environment.

// API Names
export const CHARITY_API_NAME = 'charityEventAPI';
export const USERS_API_NAME = 'usersAPI';

export const ShirtSizes = ['YS', 'YM', 'YL', 'YXL', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];

export const PageName = {
    Events: 'Events',
    All: 'All',
} as const;

export type PageNameType = (typeof PageName)[keyof typeof PageName];
